module.exports = __webpack_public_path__ + "img/meme_23.516d85e2.jpg";